import React, { useState } from 'react';

export default function ThinkyIOTIntelligenceLayer({ onBack }) {
  const [insights] = useState([
    { id: 1, issue: 'Temperature spike in Device A', rootCause: 'Sensor calibration error', recommendation: 'Recalibrate sensor', timestamp: '2025-12-18 10:12' },
    { id: 2, issue: 'Unexpected downtime on Server B', rootCause: 'High CPU load', recommendation: 'Redistribute workload', timestamp: '2025-12-18 09:45' },
    { id: 3, issue: 'Battery drain on Device C', rootCause: 'Firmware bug', recommendation: 'Update firmware', timestamp: '2025-12-17 17:30' },
    { id: 4, issue: 'Data mismatch in telemetry', rootCause: 'Gateway misconfiguration', recommendation: 'Reconfigure gateway', timestamp: '2025-12-17 16:05' },
  ]);

  return (
    <div className="min-h-screen bg-black text-white px-4 py-8">
      <button onClick={onBack} className="mb-6 px-4 py-2 bg-blue-600 rounded hover:bg-blue-500 w-24">&larr; Back</button>
      <h1 className="text-lg lg:text-xl font-bold mb-6">Think5Whys Intelligence Layer</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {insights.map(item => (
          <div key={item.id} className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm">
            <h3 className="text-lg font-semibold mb-2">{item.issue}</h3>
            <p><span className="font-semibold text-blue-400">Root Cause:</span> {item.rootCause}</p>
            <p><span className="font-semibold text-blue-400">Recommendation:</span> {item.recommendation}</p>
            <p className="text-sm text-neutral-400 mt-2">Timestamp: {item.timestamp}</p>
          </div>
        ))}
      </div>

      <section className="mt-8">
        <h2 className="text-lg font-semibold mb-3">Summary</h2>
        <ul className="list-disc list-inside text-sm">
          <li>Total Insights: {insights.length}</li>
          <li>Recent Critical Issues: {insights.filter(i => i.rootCause.includes('error') || i.rootCause.includes('bug')).length}</li>
        </ul>
      </section>
    </div>
  );
}
